// extracted by mini-css-extract-plugin
export default {"drawerContainer":"drawerContainer___WaqT5","scrollContainer":"scrollContainer___ZdxUi"};